import { createLabeledMessages } from '../../../messageUtils';
const chat = {
    showMore: 'zobraziť viac',
    showLess: 'zobraziť menej',
    flag: 'uložené'
};
export default Object.assign({}, chat, createLabeledMessages(chat));
